module.exports = __webpack_public_path__ + "img/heading_contact.20aea8df.png";